import { LoginRequest } from "../domain/requests";
import { Observable } from "rxjs";
import { Authorize } from "../domain/models";
import { RefreshToken } from "../domain/models/refresh-token";

export abstract class AccountRepository {
  abstract login(request: LoginRequest): Observable<Authorize>;
  

  abstract refreshToken(request: RefreshToken): Observable<Authorize>;
}
